import React from 'react';
import { ContentNote } from './ContentNote';
import { SectionHeading } from './SectionHeading';
interface SeoIntroProps {
  heading: string;
  paragraphs: string[];
}
export function SeoIntro({
  heading,
  paragraphs
}: SeoIntroProps) {
  return <section aria-labelledby="seo-intro" className="relative px-5 py-12 md:px-10 md:py-16" data-id="element-177" data-mp="2d4uh5563a6zt">
      <SectionHeading id="seo-intro" className="mx-auto max-w-3xl" data-id="element-178" data-mp="2hy5gymchhni8">{heading}</SectionHeading>
      <div className="mx-auto mt-8 max-w-3xl space-y-4 text-[15px] leading-relaxed text-brand-ink md:text-base" data-id="element-179" data-mp="2mvfdelyaizfk">
        {paragraphs.map(p => <p key={p.slice(0, 24)} data-id="element-180" data-mp="2wuegzq4784vp">{p}</p>)}
      </div>
      <ContentNote kind="wp" detail="100–200 words of city-specific copy, managed by corporate." data-id="element-181" data-mp="2wuwmldcr3vga" />
    </section>;
}